module.exports = __webpack_public_path__ + "assets/img/zp2.15975565.png";